<template>
    <table
        ref="table"
        class="table table-bordered table-striped table-vcenter dataTable"
        style="width: 100%;"
    >
        <thead>
        <tr>
            <th>Address</th>
            <th>Actions</th>
        </tr>
        </thead>
        <tbody @click="handleAddressEvent"></tbody>
    </table>
</template>

<script setup>

import { ref, onMounted, nextTick } from 'vue'

const props = defineProps({
    forMap: {
        type: String,
        required: true
    },
})

const emit = defineEmits(['update:address'])

const table = ref(null)

onMounted(async () => {
    await nextTick()
    initialiseDatatable()
})

function initialiseDatatable() {

    window.jQuery(table.value).dataTable({
        processing: false,
        serverSide: false,
        data: [
            {
                full_address: 'JK Storage',
                computed_button: `
                    <div class="text-center">
                        <button
                            type="button"
                            class="btn btn-success btn-sm"
                            data-id=""
                            data-address="Fosseway Business Park, A46 Fosse Ln, Newark Rd, Lincoln LN5 9EJ"
                            data-alias="JK Storage"
                            data-lat="53.17099632859564"
                            data-lng="-0.641919515358351"
                            data-locale=""
                            data-company="JK Vehicles"
                            data-for-map="${props.forMap}"
                            style="width: 130px;"
                        >
                            <i class="fa fa-fw fa-check"></i>
                            Select
                        </button>
                    </div>
                `
            },
            {
                full_address: 'JK Office',
                computed_button: `
                    <div class="text-center">
                        <button
                            type="button"
                            class="btn btn-success btn-sm"
                            data-id=""
                            data-address="13 Witham Point, Wavell Dr, Lincoln LN3 4PL"
                            data-alias="JK Office"
                            data-lat="53.23042800741681"
                            data-lng="-0.5024314638314411"
                            data-locale=""
                            data-company="JK Vehicles"
                            data-for-map="${props.forMap}"
                            style="width: 130px;"
                        >
                        <i class="fa fa-fw fa-check"></i>
                        Select
                        </button>
                    </div>
                `
            }
        ],
        autoWidth: false,
        columnDefs: [
            {
                targets: 1,
                width: '200px'
            }
        ],
        columns: [
            {
                data: 'full_address',
                orderable: false,
                searchable: false
            },
            {
                data: 'computed_button',
                orderable: false,
                searchable: false
            }
        ]
    })
}

function handleAddressEvent(e) {
    const target = e.target
    if (target.tagName === 'BUTTON') {
        // Emit the data attributes from the button
        const payload = {
            id: target.dataset.id,
            address: target.dataset.address,
            alias: target.dataset.alias,
            lat: target.dataset.lat,
            lng: target.dataset.lng,
            locale: target.dataset.locale,
            company: target.dataset.company,
            forMap: props.forMap,
        }
        emit('update:address', payload)
    }
}

</script>
